import React, { useState } from 'react';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ContactModal from "./ContactModal/ContactModal";
import Globe3D from "./Globe3D";

function Footer() {
  const [copiedPhone, setCopiedPhone] = useState(false);
  const [copiedEmail, setCopiedEmail] = useState(false);

  const copyToClipboard = (text, type) => {
    navigator.clipboard.writeText(text);
    if (type === 'phone') {
      setCopiedPhone(true);
      setTimeout(() => setCopiedPhone(false), 2000);
    } else {
      setCopiedEmail(true);
      setTimeout(() => setCopiedEmail(false), 2000);
    }
  };

  const sectionTitleStyle = {
    fontSize: 15,
    fontWeight: 700,
    color: '#fff',
    margin: '20px 0 10px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  };

  const listItemStyle = {
    fontSize: 13,
    color: 'rgba(255,255,255,0.5)',
    padding: '3px 0',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    lineHeight: 1.5,
  };

  const dotStyle = {
    color: '#4dc247',
    fontSize: 6,
    flexShrink: 0,
  };

  return (
    <footer style={{
      background: 'linear-gradient(180deg, #0a0a0f 0%, #050508 100%)',
      color: '#fff',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Top section: 3 columns — Contacts | Globe | Map */}
      <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: '60px 24px 40px',
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        gap: 40,
        alignItems: 'center',
      }} className="footer-top-grid">

        {/* Left: Contact info */}
        <div>
          <h3 style={{
            fontSize: 20,
            fontWeight: 700,
            margin: '0 0 20px',
          }}>
            <span style={{
              background: 'linear-gradient(135deg, #16b724, #4dc247)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}>Контакти</span>
          </h3>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <LocationOnIcon style={{ color: '#4dc247', fontSize: 18 }} />
              <span style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)' }}>
                м. Черкаси, вул. Юрія Іллєнка 27
              </span>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <AccessTimeIcon style={{ color: '#4dc247', fontSize: 18 }} />
              <span style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)' }}>Цілодобово 24/7</span>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
              <PhoneIcon style={{ color: '#4dc247', fontSize: 18 }} />
              <a href="tel:+380966341617" style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)', textDecoration: 'none' }}>
                +38 (096) 634 16 17
              </a>
              <button onClick={() => copyToClipboard('+380966341617', 'phone')} style={{
                background: copiedPhone ? 'rgba(22,183,36,0.3)' : 'rgba(22,183,36,0.1)',
                border: '1px solid rgba(22,183,36,0.3)',
                color: '#4dc247', padding: '3px 10px', fontSize: 11,
                borderRadius: 6, cursor: 'pointer', transition: 'all 0.2s',
              }}>
                {copiedPhone ? '✓' : 'Копіювати'}
              </button>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
              <EmailIcon style={{ color: '#4dc247', fontSize: 18 }} />
              <a href="mailto:0966341617@ukr.net" style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)', textDecoration: 'none' }}>
                0966341617@ukr.net
              </a>
              <button onClick={() => copyToClipboard('0966341617@ukr.net', 'email')} style={{
                background: copiedEmail ? 'rgba(22,183,36,0.3)' : 'rgba(22,183,36,0.1)',
                border: '1px solid rgba(22,183,36,0.3)',
                color: '#4dc247', padding: '3px 10px', fontSize: 11,
                borderRadius: 6, cursor: 'pointer', transition: 'all 0.2s',
              }}>
                {copiedEmail ? '✓' : 'Копіювати'}
              </button>
            </div>
          </div>

          {/* Social */}
          <div style={{ display: 'flex', gap: 12, marginTop: 20 }}>
            <a href="https://www.facebook.com/hotLogistics/" target="_blank" rel="noopener noreferrer" style={{
              width: 36, height: 36, borderRadius: '50%', border: '1px solid rgba(22,183,36,0.25)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: 'rgba(255,255,255,0.6)', textDecoration: 'none',
            }}>
              <FacebookIcon style={{ fontSize: 18 }} />
            </a>
            <a href="https://www.instagram.com/hot_logistics/?utm_medium=copy_link" target="_blank" rel="noopener noreferrer" style={{
              width: 36, height: 36, borderRadius: '50%', border: '1px solid rgba(22,183,36,0.25)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: 'rgba(255,255,255,0.6)', textDecoration: 'none',
            }}>
              <InstagramIcon style={{ fontSize: 18 }} />
            </a>
          </div>
        </div>

        {/* Center: 3D Globe */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Globe3D />
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.3)', textAlign: 'center', marginTop: 4 }}>
            📍 Черкаси, Україна
          </p>
        </div>

        {/* Right: Map */}
        <div>
          <h3 style={{
            fontSize: 20,
            fontWeight: 700,
            margin: '0 0 20px',
          }}>
            <span style={{
              background: 'linear-gradient(135deg, #16b724, #4dc247)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}>Де ми</span>
          </h3>
          <div style={{
            borderRadius: 14,
            overflow: 'hidden',
            border: '1px solid rgba(22,183,36,0.15)',
            height: 220,
          }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2593.87545021587!2d32.051619!3d49.449071!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d14d50ed42dfb9%3A0x40562cf61d37d1df!2sThe%20Hot%20Logistics!5e0!3m2!1sru!2sua!4v1703323072049!5m2!1sru!2sua"
              style={{ width: '100%', height: '100%', border: 'none', filter: 'grayscale(0.8) brightness(0.7) contrast(1.1)' }}
              allowFullScreen="" loading="lazy" title="The Hot Logistics location"
            />
          </div>
        </div>
      </div>

      {/* SEO Text section */}
      <div style={{
        borderTop: '1px solid rgba(255,255,255,0.06)',
        maxWidth: 1200,
        margin: '0 auto',
        padding: '40px 24px',
      }}>
        <h2 style={{
          fontSize: 18,
          fontWeight: 700,
          color: '#fff',
          lineHeight: 1.5,
          margin: '0 0 16px',
        }}>
          THE HOT LOGISTICS - це українська логістична компанія повного циклу, яка спеціалізується на вантажних перевезеннях Україна-Європа.
        </h2>

        <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.55)', lineHeight: 1.7, margin: '0 0 12px' }}>
          Ми пропонуємо міжнародні вантажні перевезення, перевезення по Україні, зернові перевезення, тент 20–22 тонни, рефрижератори, сцепки, контейнерні перевезення, експедирування, та пошук транспорту на зараз.
        </p>

        <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.55)', lineHeight: 1.7, margin: '0 0 28px' }}>
          Компанія працює з базою понад 11 000 перевірених перевізників, що дозволяє нам оперативно забезпечувати швидку подачу авто під будь-який вантаж: агропродукцію, метал, будматеріали, продукти харчування, обладнання, імпортні та експортні вантажі, палети та негабарит.
        </p>

        {/* Cards grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: 20,
        }} className="footer-seo-grid">

          {/* Ключові переваги */}
          <div style={{
            padding: '20px',
            background: 'rgba(22,183,36,0.03)',
            borderRadius: 14,
            border: '1px solid rgba(22,183,36,0.08)',
          }}>
            <h3 style={sectionTitleStyle}>🔥 Ключові переваги</h3>
            {[
              'Оперативний підбір транспорту: подача машини від 30 хвилин',
              'Вантажні перевезення 24/7',
              'Міжнародні перевезення Україна–ЄС',
              'Безпечна доставка та супровід вантажу',
              'Прозорі тарифи на перевезення вантажів',
              'Вантажоперевезення для бізнесу та агросектору',
              'Супровід логіста від завантаження до вивантаження',
              'Юридичний супровід, документи, CMR, T1, EX1',
              'Страхування вантажів за вимогою клієнта',
            ].map((item, i) => (
              <div key={i} style={listItemStyle}><span style={dotStyle}>●</span>{item}</div>
            ))}
          </div>

          {/* Спеціалізація + Географія */}
          <div style={{
            padding: '20px',
            background: 'rgba(22,183,36,0.03)',
            borderRadius: 14,
            border: '1px solid rgba(22,183,36,0.08)',
          }}>
            <h3 style={sectionTitleStyle}>🚛 Наша спеціалізація</h3>
            {[
              'Зерновози Україна–порт',
              'Перевезення тентами 20–22 т',
              'Рефрижераторні перевезення',
              'Перевезення будматеріалів',
              'Перевезення імпорту/експорту',
              'Контейнерні перевезення по Україні та ЄС',
              'Перевезення FTL / LTL',
              'Подача авто в день звернення',
            ].map((item, i) => (
              <div key={i} style={listItemStyle}><span style={dotStyle}>●</span>{item}</div>
            ))}
            <h3 style={{ ...sectionTitleStyle, marginTop: 20 }}>🌍 Географія перевезень</h3>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)', lineHeight: 1.7, margin: 0 }}>
              Польща, Румунія, Чехія, Словаччина, Угорщина, Молдова, Болгарія, Литва, Латвія, Естонія, Німеччина, Австрія, Італія, Франція, Нідерланди, Бельгія.
            </p>
          </div>

          {/* Чому обирають нас */}
          <div style={{
            padding: '20px',
            background: 'rgba(22,183,36,0.03)',
            borderRadius: 14,
            border: '1px solid rgba(22,183,36,0.08)',
          }}>
            <h3 style={sectionTitleStyle}>⭐️ Чому обирають саме нас</h3>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', lineHeight: 1.7, margin: '0 0 12px' }}>
              THE HOT LOGISTICS забезпечує швидкі вантажні перевезення, надійне експедирування, чітку комунікацію та контроль кожного етапу доставки. Ми працюємо з бізнесом у сегментах агро, промисловість, ритейл, дистрибуція, FMCG, будівництво, e-commerce та міжнародні компанії.
            </p>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', lineHeight: 1.7, margin: 0 }}>
              Наші логісти мають багаторічний досвід та щодня організовують десятки перевезень: від внутрішніх маршрутів по Україні до міжнародних рейсів у Європу. Ми гарантуємо вчасну подачу транспорту, дотримання температурних режимів, повну комунікацію з водієм, контроль маршруту, документальний супровід та повну прозорість роботи.
            </p>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div style={{
        borderTop: '1px solid rgba(255,255,255,0.06)',
        padding: '20px 24px',
        textAlign: 'center',
      }}>
        <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.25)', margin: 0 }}>
          The Hot Logistics © {new Date().getFullYear()}
        </p>
      </div>

      <ContactModal />

      <style>{`
        @media (max-width: 900px) {
          .footer-top-grid {
            grid-template-columns: 1fr !important;
            text-align: center;
          }
          .footer-seo-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </footer>
  );
}

export default Footer;
